import { Pipe, PipeTransform } from '@angular/core';
import { isValidHttpUrl, isValidString } from '@pineapplelab/util';

@Pipe({
	name: 'thumbnail'
})
export class ThumbnailPipe implements PipeTransform {

	transform(value: string, ...args: unknown[]): unknown {
		if (!isValidString(value) || !isValidHttpUrl(value)) {
			return '/../../../../assets/images/video-thumbnail-placeholder.png';
		}
		return value;
	}

}
